import HandleResponses from '@common/utils/handleResponses';
import axios from '../../../axios';

const actions = {

  async list({ commit }, params) {
    try {
      commit('SET_WALLET_LIST_LOADING', true);
      const result = await axios('wallet', { params });
      if (result && result.data) {
        commit('SET_WALLET_LIST', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('SET_WALLET_LIST_LOADING', false);
    }
  },

  async listForTransporters({ commit }, { transporterId, params }) {
    try {
      commit('SET_WALLET_TRANSPORTER_LIST_LOADING', true);
      const result = await axios(`/wallet/list/transporter/${transporterId}`, { params });
      if (result && result.data) {
        commit('SET_WALLET_TRANSPORTER_LIST', result.data);
      }
      return result.data;
    } catch (error) {
      return HandleResponses.Status(error);
    } finally {
      commit('SET_WALLET_TRANSPORTER_LIST_LOADING', false);
    }
  },

  async updateUsed({ commit }, { data }) {
    try {
      const result = await axios.put('wallet/transporter/update/', { data });
      if (result) {
        commit('SET_WALLET_USED', data.wallet_ids);
      }
      return result;
    } catch (error) {
      return HandleResponses.Status(error);
    }
  },

  async downloadWallet({}, { transporterId, dateRange }) {
    const result = await axios({
      url: `/wallet/transporter/download/${transporterId}?date_range=${dateRange}&status=[1]`,
      method: 'GET',
      responseType: 'blob',
    });
    if (result) {
      const url = window.URL.createObjectURL(new Blob([result]));
      const link = document.createElement('a');
      link.href = url;
      const now = new Date().toISOString();
      link.setAttribute('download', `wallet-unused-report-${now}.xlsx`); // or any other extension
      document.body.appendChild(link);
      link.click();
    }
  },

  async downloadConsolidatedWalletReport({}, { month, year }) {
    const result = await axios({
      url: `/wallet/transporter/consolidatedDownload?month=${month}&year=${year}&status=[1]`,
      method: 'GET',
      responseType: 'blob',
    });
    if (result) {
      const url = window.URL.createObjectURL(new Blob([result]));
      const link = document.createElement('a');
      link.href = url;
      const now = new Date().toISOString();
      link.setAttribute('download', `wallet-consolidated-unused-report-${now}.xlsx`);
      document.body.appendChild(link);
      link.click();
    }
  },

};
export default actions;
